import React, { useContext } from 'react';
import { getLabel } from '../../../data/labels';
import { getConfiguration } from '../../utils/configuration';
import { TicketPrinterContext } from '../../printer/TicketPrinterContext';
import { getEnv } from '../../env';
import '../MyBetsShareCard.css';

function SocialShareButtons(props) {
    const conf = getConfiguration();
    const printerContext = useContext(TicketPrinterContext);
    const printTicketEnabled = conf.pto !== undefined ? conf.pto : true;
    const { ticketId, copyLinkText, onCopyLink, downloadStatus, onDownloadClick } = props;

    return (
        <div id="checkbet-share-buttons-container" className="mb_7_1_2" style={{ display: 'flex', alignItems: 'center' }} >
            {printTicketEnabled && (
                <div className="my-bets-printer | mb_7_1_1"
                    onClick={() => printerContext.printTicket(ticketId, false)}>
                    <img
                        src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`}
                        alt="Print button"
                        className="mb_7_1_1_1"
                    />
                </div>
            )}
            <div className="checkbet-button mr-auto | mb_7_1_2_2" onClick={onCopyLink}>
                {copyLinkText
                    ? copyLinkText
                    : <>{getLabel('checkbet.copy_link')} <i className="fa fa-copy ml-2 | mb_7_1_2_2_1"></i></>
                }
            </div>
            {conf.sdt && (
                <div
                    className={[
                        'share-download-ticket',
                        downloadStatus === 'loading' ? 'share-download-ticket--loading' : '',
                        downloadStatus === 'error' ? 'share-download-ticket--error' : '',
                    ].join(' ')}
                    onClick={downloadStatus === 'idle' ? onDownloadClick : undefined}
                >
                    <span>
                        {downloadStatus === 'loading' && 'Generazione...'}
                        {downloadStatus === 'error' && 'Errore di download'}
                        {downloadStatus === 'idle' && getLabel('checkbet.download', 'Download')}
                    </span>
                </div>
            )}
        </div>
    );
}

export default SocialShareButtons;